


















import { Component, Mixins, Prop, Ref } from 'vue-property-decorator'

import { prepareAnchorLink } from '../components/SelectEntityWizard/includes/helpers'
import ClipboardCopyMixin from '../logic/helpers/ClipboardCopyMixin'

const borderColorClass = [ 'outline-primary' ]

@Component({
})
export default class HighlightAnchor extends Mixins<ClipboardCopyMixin>(ClipboardCopyMixin) {

  @Prop({ type: String, required: false }) anchorKey!:string

  @Prop({ type: Boolean, required: true, default: false }) hasAnchorIcon!:boolean

  @Prop() elToHighlight!: Element | string | undefined

  @Ref('fieldRef') fieldRef!:HTMLDivElement

  get anchorLink():string {
    let anchor = ''

    if (this.anchorKey) {
      anchor = "#" + this.anchorKey
    }

    const fullUrl = window.location.origin + window.location.pathname + window.location.search + anchor

    return prepareAnchorLink(fullUrl, this.$route)
  }

  removeHighlight(el: Element) {
    setTimeout(() => {
      borderColorClass.forEach(value => el.classList.remove(value))
    }, 3500)
  }

  mounted():void {
    this.$nextTick(() => {
      const anchorHash = `#${ this.anchorKey }`

      if (this.$route.hash === anchorHash) {
        if (this.elToHighlight instanceof Element) {
          this.elToHighlight.classList.add(...borderColorClass)

          this.removeHighlight(this.elToHighlight)
        } else if (typeof this.elToHighlight === 'string') {
          const el = document.querySelector(this.elToHighlight)

          if (el) {
            el.classList.add(...borderColorClass)

            this.removeHighlight(el)
          }
        } else {
          if (this.fieldRef) {
            this.fieldRef.classList.add(...borderColorClass)
            this.removeHighlight(this.fieldRef)
          }
        }
      }
    })
  }
}
